import { render, staticRenderFns } from "./menuLaboratorioExam.vue?vue&type=template&id=c8f23ce4&scoped=true"
import script from "./menuLaboratorioExam.vue?vue&type=script&lang=js"
export * from "./menuLaboratorioExam.vue?vue&type=script&lang=js"
import style0 from "./menuLaboratorioExam.vue?vue&type=style&index=0&id=c8f23ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f23ce4",
  null
  
)

export default component.exports